import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  InputGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
} from "reactstrap";
import { DatabaseMgmt } from "../../../../services/DatabaseService/DatabaseMgmt";

import { BreadCrumb } from "../../component/BreadCrumb";
import { RestroUserLogData } from "../../../../services/DatabaseService/RestroUserLogData";
import CustomDataTable from "../../../../Components/CustomTable/CustomTable";
import { FormatDate, formatDate, formatDateTime, getTimeOnly } from "../../../../Components/Common/FormatDate";
import { Link, useNavigate } from "react-router-dom";
import { Triangle } from 'react-loader-spinner';

export default function RestroUserLogs() {
  const customStyles = {
    headCells: {
      style: {
        fontSize: "0.92rem",
        fontWeight: 610,
        width: "max-content",
      },
    },
    rows: {
      style: {
        fontSize: "0.9rem",
      },
    },
  };
  const [loading, setLoading] = useState(false);
  const [dataList, setDataList] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const result = await RestroUserLogData.getAll();
        setDataList(result);
      } catch (error) {
        console.error("Failed to load data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  console.log(dataList);
  const [filterText, setFilterText] = useState("");
  const [addModal, setAddModal] = useState(false);

  const handleFilterChange = (e) => {
    setFilterText(e.target.value);
  };

  const filteredData = dataList.filter(
    (item) =>
      (item.name?.toLowerCase() || "").includes(
        filterText?.toLowerCase() || ""
      ) ||
      (item.database?.toLowerCase() || "").includes(
        filterText?.toLowerCase() || ""
      )
  );

  const columns = [
    {
      name: "S No",
      selector: (row, index) => <div className="ps-3">{index + 1}</div>,
      sortable: true,

      width: "90px",
    },
    {
      name: "Log In Time",
      selector: (row) => formatDateTime(row.logTime),
      sortable: true,
      width: "200px",
    },
    {
      name: "Log For",
      selector: (row) => row.logFor,
      sortable: true,
      width: "150px",
    },
    {
      name: "Detail",
      selector: (row) => <span title={row.logDetails}  
      style={{
        maxWidth: "750px",
        display: "inline-block",
        // whiteSpace: "wrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        verticalAlign: "middle"
      }}>{row.logDetails}</span>,
      sortable: true,
      
      // width: "300px",
    },
    {
      name: "Status",
      // selector: (row) => row.status,
      width: "100px",
      sortable: true,

      cell: (row) => (
        <span
          className={`badge ${
            row.status === "Success" ? "bg-success" : "bg-danger"
          }`}
          style={{ minWidth: "50px", display: "inline-block", textAlign: "center" }}
          // onClick={() => console.log("Button clicked for", row)}
        >
          {row.status === "Success" ? "Success" : "Failed"}
          </span>
      )
    },
    {
      name: "Action",
      width:"100px",
      selector: (row) => (
        <div>
          {/* <Button
            color="btn btn-soft-warning"
            className="btn-sm ms-1"
            // onClick={() => {
            //   setAddModal(true);
            //   // setSelectedCustomer(row);
            // }}
          >
            <i className="ri-edit-line" />
          </Button> */}
          <Link to={`/restrolog/detail/${row?.apiKey}`}>
            <Button color="btn btn-soft-success" className="btn-sm">
              <i className="bx bx-show" />
            </Button>
          </Link>
          {/* <Button
            className="btn btn-soft-danger btn-sm ms-1"
            color="danger"
            // onClick={() => handleDeleteClick(row.id)}
          >
            <i className="ri-delete-bin-5-line" />
          </Button> */}
        </div>
      ),
      center: true,
    },
  ];

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Restro User Log List" pageTitle="Database" />
      </div>
      <Card className="d-none d-lg-block">
        <CardBody>
          <CustomDataTable
            responsive
            striped
            pagination
            fixedHeader
            persistTableHead
            progressPending={loading}
            customStyles={customStyles}
            progressComponent={
              <div className="my-3">
                <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                />
                <h5 className="mt-1">Loading...</h5>
              </div>
            }
            columns={columns}
            data={filteredData || []}
          />
        </CardBody>
      </Card>
      {loading ? (
        <div className="my-5 d-flex d-lg-none justify-content-center">
          <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                />
          {/* <h5 className="mt-1">Loading...</h5> */}
        </div>
      ) : (
        <>
          {filteredData?.map((item, index) => (
            <Card
              key={item.id || index}
              className="mb-3 shadow-sm d-block d-lg-none mt-2"
            >
              <CardBody>
                <Row>
                  <Col xs={10}>
                    {/* <h6 className="mb-2">
                      <strong>S No:</strong> {index + 1}
                    </h6> */}
                    <div>
                    <h6 className="mb-0">
                      <strong>Date:</strong> {formatDate(item.logTime)}
                    </h6>
                    <small className="text-muted">
                    Time:{getTimeOnly(item.logTime)}
                   </small>
                   </div>
                    
                    <h6 className="mb-2">
                      <strong>Log For:</strong> {item.logFor}
                    </h6>
                    <h6 className="mb-2">
                      <strong>Detail:</strong> {item.logDetails}
                    </h6>

                    {item.status === "Success" ? (
                      <button
                        className="btn btn-success px-1 px-sm-2"
                        onClick={() => setAddModal(true)}
                      >
                        Success
                      </button>
                    ) : (
                      <button
                        className="btn btn-danger px-1 px-sm-2"
                        onClick={() => setAddModal(true)}
                      >
                        Failed
                      </button>
                    )}
                  </Col>
                  <Col xs={2}>
                    <div>
                      <Dropdown
                        isOpen={item.dropdownOpen || false}
                        toggle={(e) => {
                          e.stopPropagation();
                          setDataList((prev) =>
                            prev.map((dbItem) =>
                              dbItem.id === item.id
                                ? {
                                    ...dbItem,
                                    dropdownOpen: !dbItem.dropdownOpen,
                                  }
                                : { ...dbItem, dropdownOpen: false }
                            )
                          );
                        }}
                        direction="down"
                      >
                        <DropdownToggle
                          color="primary"
                          outline
                          className="btn-sm shadow-sm rounded-circle"
                        >
                          <i className="ri-more-2-fill"></i>
                        </DropdownToggle>
                        <DropdownMenu end>
                          <DropdownItem
                            onClick={() =>
                              navigate(`/restrolog/detail/${item.apiKey}`)
                            }
                          >
                            <i className="ri-eye-line text-warning me-2"></i>{" "}
                            view
                          </DropdownItem>
                          {/* <DropdownItem>
                            <i className="ri-delete-bin-5-line text-danger me-2"></i>{" "}
                            Delete
                          </DropdownItem> */}
                        </DropdownMenu>
                      </Dropdown>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          ))}
        </>
      )}
    </div>
  );
}
